import { ICheckoutDetailParams } from 'core/model/interfaces/checkout.interface';
import { checkoutData } from './checkout.data';
import { mapToCheckoutDetail } from './checkout.mappers';

export const checkoutService = {
  getCartDetail: async (customerId: number, params?: ICheckoutDetailParams) =>
    mapToCheckoutDetail(await checkoutData.getCartDetail(customerId, params)),
};
